module.exports = __webpack_public_path__ + "static/media/cert_1.dac007f5.jpg";